import {Skeleton} from "primereact/skeleton"
import {default as cx} from "classnames"

import MetricCard from "../MetricCard.jsx"
import {useMetricsQuery, fyLabel} from "./util.jsx"

const SCHEDULE_BANDS = [
    {key: "Behind", header: "Behind", background: "bg-light-danger border border-danger"},
    {key: "On-Schedule", header: "On Schedule", background: "bg-light-success border border-success"},
    {key: "Ahead", header: "Ahead", background: "bg-light-primary border border-primary"},
]

const ScheduleCard = ({header, text, background, isLoading}) => (
    <div className="d-flex flex-fill">
        <div className={cx("card flex-center flex-grow-1 pb-4", background)}>
            <div className="card-header py-0 border-0 text-center flex-fill d-flex flex-center min-h-40px">
                <h3 className="card-title align-items-start flex-column flex-fill flex-center text-center fw-bold fs-4 min-h-30px pt-4">
                    {header}
                </h3>
            </div>
            <div className="card-body d-flex flex-center p-0">
                <div className="d-flex flex-column">
                    {isLoading ? (
                        <Skeleton className="w-100 h-60px" />
                    ) : (
                        <div className="d-flex flex-row justify-content-center align-items-center fw-bolder fs-3x">
                            {text}
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
)

const DomainScoreTable = ({categories, sortedWeeks, isLoading}) => {
    const lastWeek = sortedWeeks.length

    return (
        <div className="table-responsive">
            <table className="table align-middle table-rounded table-row-bordered border gs-4 my-0 fs-6 w-100">
                <thead className="text-start text-light text-uppercase bg-gray-700 align-middle fs-7 fw-bold">
                    <tr>
                        <th>Week</th>
                        {categories.map((category) => (
                            <th key={category} className="text-center">
                                {category}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {isLoading
                        ? Array.from({length: 6}, (_, r) => (
                              <tr key={`skeleton-${r}`}>
                                  {Array.from({length: categories.length + 1}, (_, c) => (
                                      <td key={`skeleton-${r}-${c}`}>
                                          <Skeleton className="w-100 h-30px" />
                                      </td>
                                  ))}
                              </tr>
                          ))
                        : sortedWeeks.map((row) => (
                              <tr key={`week-${row.week}`}>
                                  <td className="fw-bold text-nowrap">
                                      Week {row.week}
                                      {row.week === lastWeek ? "+" : ""}
                                  </td>
                                  {categories.map((category) => {
                                      return (
                                          <td key={`week-${row.week}-${category}`} className="text-center">
                                              {row.scores[category] == null ? "—" : row.scores[category].toFixed(2)}
                                          </td>
                                      )
                                  })}
                              </tr>
                          ))}
                </tbody>
            </table>
        </div>
    )
}

const MetricsPerformance = ({filters = {}}) => {
    // const {
    //     data: performanceData,
    //     isLoading: performanceLoading,
    //     error: performanceError,
    // } = useMetricsQuery("performance", filters, {
    //     categories: [],
    //     rfp_outcomes: {
    //         completed_total: 0,
    //         completed_without_rfp: 0,
    //         completed_with_three_plus_rfp: 0,
    //         avg_week_to_first_rfp: null,
    //     },
    //     by_week: [],
    // })

    const performanceError = null
    const performanceLoading = false
    const data2027 = {
        "categories": [
            "Clinical Practice",
            "Medication Management",
            "Assessment & Care",
            "Prevention, Safety & Quality",
            "Education, Communication & Collaboration",
            "Professionalism"
        ],
        "rfp_outcomes": {
            "completed_total": 229,
            "completed_without_rfp": 20,
            "completed_with_three_plus_rfp": 96,
            "avg_week_to_first_rfp": 5.5
        },
        "by_week": {
            "1": {
                "Assessment & Care": 44.1,
                "Clinical Practice": 51.8,
                "Education, Communication & Collaboration": 52.4,
                "Medication Management": 54.2,
                "Prevention, Safety & Quality": 60.9,
                "Professionalism": 71.5,
                "Readiness": 42.8
            },
            "2": {
                "Assessment & Care": 52.5,
                "Clinical Practice": 59.0,
                "Education, Communication & Collaboration": 60.9,
                "Medication Management": 60.2,
                "Prevention, Safety & Quality": 67.9,
                "Professionalism": 77.4,
                "Readiness": 49.7
            },
            "3": {
                "Assessment & Care": 59.9,
                "Clinical Practice": 64.9,
                "Education, Communication & Collaboration": 67.4,
                "Medication Management": 64.6,
                "Prevention, Safety & Quality": 72.0,
                "Professionalism": 81.6,
                "Readiness": 55.8
            },
            "4": {
                "Assessment & Care": 67.4,
                "Clinical Practice": 71.5,
                "Education, Communication & Collaboration": 73.8,
                "Medication Management": 73.2,
                "Prevention, Safety & Quality": 78.5,
                "Professionalism": 84.9,
                "Readiness": 62.5
            },
            "5": {
                "Assessment & Care": 70.1,
                "Clinical Practice": 72.7,
                "Education, Communication & Collaboration": 76.0,
                "Medication Management": 73.6,
                "Prevention, Safety & Quality": 80.1,
                "Professionalism": 86.0,
                "Readiness": 66.2
            },
            "6": {
                "Assessment & Care": 73.7,
                "Clinical Practice": 75.6,
                "Education, Communication & Collaboration": 80.2,
                "Medication Management": 77.6,
                "Prevention, Safety & Quality": 83.4,
                "Professionalism": 90.2,
                "Readiness": 69.6
            },
            "7": {
                "Assessment & Care": 77.7,
                "Clinical Practice": 78.8,
                "Education, Communication & Collaboration": 81.8,
                "Medication Management": 81.0,
                "Prevention, Safety & Quality": 85.3,
                "Professionalism": 90.7,
                "Readiness": 73.8
            },
            "8": {
                "Assessment & Care": 77.3,
                "Clinical Practice": 78.0,
                "Education, Communication & Collaboration": 82.9,
                "Medication Management": 80.7,
                "Prevention, Safety & Quality": 86.2,
                "Professionalism": 91.2,
                "Readiness": 73.8
            },
            "9": {
                "Assessment & Care": 78.4,
                "Clinical Practice": 79.8,
                "Education, Communication & Collaboration": 82.7,
                "Medication Management": 81.3,
                "Prevention, Safety & Quality": 85.3,
                "Professionalism": 90.7,
                "Readiness": 77.3
            },
            "10": {
                "Assessment & Care": 83.0,
                "Clinical Practice": 82.5,
                "Education, Communication & Collaboration": 85.8,
                "Medication Management": 83.0,
                "Prevention, Safety & Quality": 87.9,
                "Professionalism": 90.1,
                "Readiness": 81.5
            },
            "11": {
                "Assessment & Care": 84.0,
                "Clinical Practice": 84.4,
                "Education, Communication & Collaboration": 86.9,
                "Medication Management": 84.7,
                "Prevention, Safety & Quality": 89.8,
                "Professionalism": 92.2,
                "Readiness": 82.0
            },
            "12": {
                "Assessment & Care": 83.3,
                "Clinical Practice": 82.5,
                "Education, Communication & Collaboration": 84.4,
                "Medication Management": 83.3,
                "Prevention, Safety & Quality": 85.4,
                "Professionalism": 92.8,
                "Readiness": 80.4
            },
            "13": {
                "Assessment & Care": 83.7,
                "Clinical Practice": 88.0,
                "Education, Communication & Collaboration": 90.0,
                "Medication Management": 87.6,
                "Prevention, Safety & Quality": 90.7,
                "Professionalism": 98.7,
                "Readiness": 84.0
            },
            "14": {
                "Assessment & Care": 52.5,
                "Clinical Practice": 61.0,
                "Education, Communication & Collaboration": 66.2,
                "Medication Management": 73.3,
                "Prevention, Safety & Quality": 71.2,
                "Professionalism": 85.0,
                "Readiness": 52.5
            },
            "15": {
                "Assessment & Care": 85.0,
                "Clinical Practice": 81.3,
                "Education, Communication & Collaboration": 91.7,
                "Medication Management": 75.6,
                "Prevention, Safety & Quality": 96.7,
                "Professionalism": 100.0,
                "Readiness": 73.3
            },
            "16": {
                "Assessment & Care": 62.5,
                "Clinical Practice": 70.0,
                "Education, Communication & Collaboration": 77.5,
                "Medication Management": 60.0,
                "Prevention, Safety & Quality": 80.0,
                "Professionalism": 90.0,
                "Readiness": 60.0
            },
            "17": {
                "Assessment & Care": 90.0,
                "Clinical Practice": 92.0,
                "Education, Communication & Collaboration": 100.0,
                "Medication Management": 100.0,
                "Prevention, Safety & Quality": 100.0,
                "Professionalism": 100.0,
                "Readiness": 90.0
            },
            "18": {
                "Assessment & Care": 87.5,
                "Clinical Practice": 88.0,
                "Education, Communication & Collaboration": 85.0,
                "Medication Management": 80.0,
                "Prevention, Safety & Quality": 90.0,
                "Professionalism": 90.0,
                "Readiness": 85.0
            },
            "19": {
                "Assessment & Care": 80.0,
                "Clinical Practice": 80.0,
                "Education, Communication & Collaboration": 80.0,
                "Medication Management": 80.0,
                "Prevention, Safety & Quality": 80.0,
                "Professionalism": 80.0,
                "Readiness": 80.0
            }
        }
    }

    const data2026 = {
        "categories": [
            "Clinical Practice",
            "Medication Management",
            "Assessment & Care",
            "Prevention, Safety & Quality",
            "Education, Communication & Collaboration",
            "Professionalism"
        ],
        "rfp_outcomes": {
            "completed_total": 692,
            "completed_without_rfp": 125,
            "completed_with_three_plus_rfp": 265,
            "avg_week_to_first_rfp": 6.0
        },
        "by_week": {
            "1": {
                "Assessment & Care": 43.9,
                "Clinical Practice": 50.8,
                "Education, Communication & Collaboration": 50.3,
                "Medication Management": 51.9,
                "Prevention, Safety & Quality": 58.9,
                "Professionalism": 69.7,
                "Readiness": 39.9
            },
            "2": {
                "Assessment & Care": 51.8,
                "Clinical Practice": 58.2,
                "Education, Communication & Collaboration": 60.7,
                "Medication Management": 60.1,
                "Prevention, Safety & Quality": 66.7,
                "Professionalism": 76.3,
                "Readiness": 48.1
            },
            "3": {
                "Assessment & Care": 59.0,
                "Clinical Practice": 63.8,
                "Education, Communication & Collaboration": 67.2,
                "Medication Management": 66.3,
                "Prevention, Safety & Quality": 71.4,
                "Professionalism": 79.2,
                "Readiness": 54.4
            },
            "4": {
                "Assessment & Care": 63.9,
                "Clinical Practice": 68.0,
                "Education, Communication & Collaboration": 71.8,
                "Medication Management": 69.3,
                "Prevention, Safety & Quality": 75.2,
                "Professionalism": 83.5,
                "Readiness": 59.1
            },
            "5": {
                "Assessment & Care": 67.0,
                "Clinical Practice": 70.5,
                "Education, Communication & Collaboration": 74.4,
                "Medication Management": 72.3,
                "Prevention, Safety & Quality": 77.2,
                "Professionalism": 83.7,
                "Readiness": 62.7
            },
            "6": {
                "Assessment & Care": 68.2,
                "Clinical Practice": 70.3,
                "Education, Communication & Collaboration": 74.2,
                "Medication Management": 73.2,
                "Prevention, Safety & Quality": 78.2,
                "Professionalism": 85.2,
                "Readiness": 64.3
            },
            "7": {
                "Assessment & Care": 73.1,
                "Clinical Practice": 75.5,
                "Education, Communication & Collaboration": 79.6,
                "Medication Management": 76.4,
                "Prevention, Safety & Quality": 82.0,
                "Professionalism": 88.0,
                "Readiness": 70.3
            },
            "8": {
                "Assessment & Care": 74.3,
                "Clinical Practice": 76.2,
                "Education, Communication & Collaboration": 79.4,
                "Medication Management": 76.7,
                "Prevention, Safety & Quality": 82.7,
                "Professionalism": 88.0,
                "Readiness": 71.2
            },
            "9": {
                "Assessment & Care": 74.8,
                "Clinical Practice": 76.2,
                "Education, Communication & Collaboration": 79.6,
                "Medication Management": 77.4,
                "Prevention, Safety & Quality": 82.1,
                "Professionalism": 87.3,
                "Readiness": 73.8
            },
            "10": {
                "Assessment & Care": 75.2,
                "Clinical Practice": 77.4,
                "Education, Communication & Collaboration": 81.5,
                "Medication Management": 78.0,
                "Prevention, Safety & Quality": 83.1,
                "Professionalism": 88.0,
                "Readiness": 75.6
            },
            "11": {
                "Assessment & Care": 77.3,
                "Clinical Practice": 80.2,
                "Education, Communication & Collaboration": 85.5,
                "Medication Management": 82.2,
                "Prevention, Safety & Quality": 88.1,
                "Professionalism": 91.8,
                "Readiness": 78.9
            },
            "12": {
                "Assessment & Care": 75.5,
                "Clinical Practice": 79.6,
                "Education, Communication & Collaboration": 82.6,
                "Medication Management": 80.9,
                "Prevention, Safety & Quality": 85.5,
                "Professionalism": 89.4,
                "Readiness": 77.0
            },
            "13": {
                "Assessment & Care": 77.8,
                "Clinical Practice": 79.4,
                "Education, Communication & Collaboration": 82.8,
                "Medication Management": 80.6,
                "Prevention, Safety & Quality": 85.8,
                "Professionalism": 89.4,
                "Readiness": 77.1
            },
            "14": {
                "Assessment & Care": 79.1,
                "Clinical Practice": 84.5,
                "Education, Communication & Collaboration": 86.8,
                "Medication Management": 80.4,
                "Prevention, Safety & Quality": 88.7,
                "Professionalism": 91.2,
                "Readiness": 80.2
            },
            "15": {
                "Assessment & Care": 89.6,
                "Clinical Practice": 88.9,
                "Education, Communication & Collaboration": 91.8,
                "Medication Management": 90.1,
                "Prevention, Safety & Quality": 92.8,
                "Professionalism": 95.4,
                "Readiness": 85.0
            },
            "16": {
                "Assessment & Care": 88.0,
                "Clinical Practice": 85.0,
                "Education, Communication & Collaboration": 88.9,
                "Medication Management": 90.4,
                "Prevention, Safety & Quality": 92.6,
                "Professionalism": 93.6,
                "Readiness": 83.9
            },
            "17": {
                "Assessment & Care": 84.0,
                "Clinical Practice": 82.0,
                "Education, Communication & Collaboration": 87.5,
                "Medication Management": 88.7,
                "Prevention, Safety & Quality": 90.5,
                "Professionalism": 92.0,
                "Readiness": 76.0
            },
            "18": {
                "Assessment & Care": 79.3,
                "Clinical Practice": 78.9,
                "Education, Communication & Collaboration": 83.6,
                "Medication Management": 79.0,
                "Prevention, Safety & Quality": 85.7,
                "Professionalism": 91.0,
                "Readiness": 76.4
            },
            "19": {
                "Assessment & Care": 87.5,
                "Clinical Practice": 85.5,
                "Education, Communication & Collaboration": 88.8,
                "Medication Management": 90.0,
                "Prevention, Safety & Quality": 89.4,
                "Professionalism": 90.0,
                "Readiness": 86.2
            },
            "20": {
                "Assessment & Care": 82.0,
                "Clinical Practice": 78.8,
                "Education, Communication & Collaboration": 82.5,
                "Medication Management": 82.7,
                "Prevention, Safety & Quality": 85.5,
                "Professionalism": 93.3,
                "Readiness": 82.0
            }
        }
    }

    const data2025 = {
        "categories": [
            "Clinical Practice",
            "Medication Management",
            "Assessment & Care",
            "Prevention, Safety & Quality",
            "Education, Communication & Collaboration",
            "Professionalism"
        ],
        "rfp_outcomes": {
            "completed_total": 539,
            "completed_without_rfp": 90,
            "completed_with_three_plus_rfp": 216,
            "avg_week_to_first_rfp": 5.6
        },
        "by_week": {
            "1": {
                "Assessment & Care": 44.0,
                "Clinical Practice": 50.3,
                "Education, Communication & Collaboration": 50.4,
                "Medication Management": 52.3,
                "Prevention, Safety & Quality": 59.4,
                "Professionalism": 70.4,
                "Readiness": 40.5
            },
            "2": {
                "Assessment & Care": 54.2,
                "Clinical Practice": 60.4,
                "Education, Communication & Collaboration": 62.3,
                "Medication Management": 62.1,
                "Prevention, Safety & Quality": 68.3,
                "Professionalism": 78.7,
                "Readiness": 51.5
            },
            "3": {
                "Assessment & Care": 60.5,
                "Clinical Practice": 65.2,
                "Education, Communication & Collaboration": 69.0,
                "Medication Management": 66.8,
                "Prevention, Safety & Quality": 72.8,
                "Professionalism": 81.6,
                "Readiness": 56.3
            },
            "4": {
                "Assessment & Care": 65.9,
                "Clinical Practice": 69.9,
                "Education, Communication & Collaboration": 73.0,
                "Medication Management": 71.5,
                "Prevention, Safety & Quality": 77.0,
                "Professionalism": 84.8,
                "Readiness": 61.4
            },
            "5": {
                "Assessment & Care": 67.9,
                "Clinical Practice": 71.8,
                "Education, Communication & Collaboration": 74.7,
                "Medication Management": 72.7,
                "Prevention, Safety & Quality": 77.8,
                "Professionalism": 85.3,
                "Readiness": 64.0
            },
            "6": {
                "Assessment & Care": 70.5,
                "Clinical Practice": 74.2,
                "Education, Communication & Collaboration": 77.4,
                "Medication Management": 75.4,
                "Prevention, Safety & Quality": 81.3,
                "Professionalism": 87.4,
                "Readiness": 67.4
            },
            "7": {
                "Assessment & Care": 73.9,
                "Clinical Practice": 75.3,
                "Education, Communication & Collaboration": 79.6,
                "Medication Management": 77.7,
                "Prevention, Safety & Quality": 82.0,
                "Professionalism": 88.4,
                "Readiness": 70.3
            },
            "8": {
                "Assessment & Care": 75.7,
                "Clinical Practice": 77.4,
                "Education, Communication & Collaboration": 81.0,
                "Medication Management": 78.7,
                "Prevention, Safety & Quality": 83.0,
                "Professionalism": 88.6,
                "Readiness": 71.7
            },
            "9": {
                "Assessment & Care": 77.0,
                "Clinical Practice": 77.9,
                "Education, Communication & Collaboration": 81.8,
                "Medication Management": 79.9,
                "Prevention, Safety & Quality": 83.2,
                "Professionalism": 89.3,
                "Readiness": 73.7
            },
            "10": {
                "Assessment & Care": 78.5,
                "Clinical Practice": 79.8,
                "Education, Communication & Collaboration": 83.5,
                "Medication Management": 82.7,
                "Prevention, Safety & Quality": 85.2,
                "Professionalism": 90.7,
                "Readiness": 76.4
            },
            "11": {
                "Assessment & Care": 78.7,
                "Clinical Practice": 82.3,
                "Education, Communication & Collaboration": 85.7,
                "Medication Management": 83.1,
                "Prevention, Safety & Quality": 87.5,
                "Professionalism": 91.5,
                "Readiness": 79.1
            },
            "12": {
                "Assessment & Care": 77.3,
                "Clinical Practice": 79.5,
                "Education, Communication & Collaboration": 83.9,
                "Medication Management": 82.4,
                "Prevention, Safety & Quality": 84.5,
                "Professionalism": 92.1,
                "Readiness": 77.0
            },
            "13": {
                "Assessment & Care": 76.5,
                "Clinical Practice": 80.1,
                "Education, Communication & Collaboration": 82.4,
                "Medication Management": 82.9,
                "Prevention, Safety & Quality": 83.7,
                "Professionalism": 88.8,
                "Readiness": 78.0
            },
            "14": {
                "Assessment & Care": 85.4,
                "Clinical Practice": 83.3,
                "Education, Communication & Collaboration": 87.7,
                "Medication Management": 88.6,
                "Prevention, Safety & Quality": 89.4,
                "Professionalism": 91.5,
                "Readiness": 79.3
            },
            "15": {
                "Assessment & Care": 88.0,
                "Clinical Practice": 85.3,
                "Education, Communication & Collaboration": 91.6,
                "Medication Management": 90.7,
                "Prevention, Safety & Quality": 93.1,
                "Professionalism": 94.9,
                "Readiness": 84.7
            },
            "16": {
                "Assessment & Care": 85.5,
                "Clinical Practice": 86.9,
                "Education, Communication & Collaboration": 91.2,
                "Medication Management": 89.9,
                "Prevention, Safety & Quality": 91.7,
                "Professionalism": 92.3,
                "Readiness": 84.4
            },
            "17": {
                "Assessment & Care": 83.1,
                "Clinical Practice": 84.7,
                "Education, Communication & Collaboration": 89.6,
                "Medication Management": 86.9,
                "Prevention, Safety & Quality": 92.7,
                "Professionalism": 96.9,
                "Readiness": 84.6
            },
            "18": {
                "Assessment & Care": 83.8,
                "Clinical Practice": 80.0,
                "Education, Communication & Collaboration": 82.9,
                "Medication Management": 87.8,
                "Prevention, Safety & Quality": 84.6,
                "Professionalism": 88.3,
                "Readiness": 78.3
            },
            "19": {
                "Assessment & Care": 92.5,
                "Clinical Practice": 89.3,
                "Education, Communication & Collaboration": 88.3,
                "Medication Management": 90.0,
                "Prevention, Safety & Quality": 97.5,
                "Professionalism": 97.8,
                "Readiness": 83.3
            },
            "20": {
                "Assessment & Care": 87.5,
                "Clinical Practice": 88.0,
                "Education, Communication & Collaboration": 90.0,
                "Medication Management": 86.7,
                "Prevention, Safety & Quality": 90.0,
                "Professionalism": 90.0,
                "Readiness": 90.0
            }
        }
    }

    const data2024 = {
        "categories": [
            "Clinical Practice",
            "Medication Management",
            "Assessment & Care",
            "Prevention, Safety & Quality",
            "Education, Communication & Collaboration",
            "Professionalism"
        ],
        "rfp_outcomes": {
            "completed_total": 109,
            "completed_without_rfp": 28,
            "completed_with_three_plus_rfp": 33,
            "avg_week_to_first_rfp": 6.3
        },
        "by_week": {
            "1": {
                "Assessment & Care": 44.9,
                "Clinical Practice": 49.9,
                "Education, Communication & Collaboration": 51.7,
                "Medication Management": 55.6,
                "Prevention, Safety & Quality": 60.8,
                "Professionalism": 72.4,
                "Readiness": 36.4
            },
            "2": {
                "Assessment & Care": 51.8,
                "Clinical Practice": 57.5,
                "Education, Communication & Collaboration": 56.9,
                "Medication Management": 61.6,
                "Prevention, Safety & Quality": 64.7,
                "Professionalism": 73.5,
                "Readiness": 43.4
            },
            "3": {
                "Assessment & Care": 56.5,
                "Clinical Practice": 61.8,
                "Education, Communication & Collaboration": 65.3,
                "Medication Management": 66.6,
                "Prevention, Safety & Quality": 71.1,
                "Professionalism": 77.5,
                "Readiness": 50.4
            },
            "4": {
                "Assessment & Care": 60.2,
                "Clinical Practice": 64.5,
                "Education, Communication & Collaboration": 67.3,
                "Medication Management": 68.8,
                "Prevention, Safety & Quality": 72.3,
                "Professionalism": 77.9,
                "Readiness": 54.8
            },
            "5": {
                "Assessment & Care": 65.7,
                "Clinical Practice": 69.7,
                "Education, Communication & Collaboration": 72.5,
                "Medication Management": 72.5,
                "Prevention, Safety & Quality": 76.1,
                "Professionalism": 82.3,
                "Readiness": 62.1
            },
            "6": {
                "Assessment & Care": 64.5,
                "Clinical Practice": 69.4,
                "Education, Communication & Collaboration": 73.8,
                "Medication Management": 71.9,
                "Prevention, Safety & Quality": 76.8,
                "Professionalism": 85.0,
                "Readiness": 63.6
            },
            "7": {
                "Assessment & Care": 72.8,
                "Clinical Practice": 74.9,
                "Education, Communication & Collaboration": 79.8,
                "Medication Management": 77.4,
                "Prevention, Safety & Quality": 80.3,
                "Professionalism": 87.4,
                "Readiness": 69.8
            },
            "8": {
                "Assessment & Care": 72.6,
                "Clinical Practice": 77.8,
                "Education, Communication & Collaboration": 80.7,
                "Medication Management": 78.9,
                "Prevention, Safety & Quality": 81.8,
                "Professionalism": 87.7,
                "Readiness": 73.3
            },
            "9": {
                "Assessment & Care": 67.8,
                "Clinical Practice": 73.9,
                "Education, Communication & Collaboration": 76.2,
                "Medication Management": 77.5,
                "Prevention, Safety & Quality": 80.5,
                "Professionalism": 86.3,
                "Readiness": 68.9
            },
            "10": {
                "Assessment & Care": 77.7,
                "Clinical Practice": 78.3,
                "Education, Communication & Collaboration": 84.6,
                "Medication Management": 81.3,
                "Prevention, Safety & Quality": 84.8,
                "Professionalism": 90.3,
                "Readiness": 77.3
            },
            "11": {
                "Assessment & Care": 68.7,
                "Clinical Practice": 73.9,
                "Education, Communication & Collaboration": 78.7,
                "Medication Management": 78.2,
                "Prevention, Safety & Quality": 80.5,
                "Professionalism": 88.1,
                "Readiness": 74.7
            },
            "12": {
                "Assessment & Care": 74.6,
                "Clinical Practice": 81.7,
                "Education, Communication & Collaboration": 87.5,
                "Medication Management": 83.8,
                "Prevention, Safety & Quality": 87.9,
                "Professionalism": 94.8,
                "Readiness": 81.4
            },
            "13": {
                "Assessment & Care": 81.4,
                "Clinical Practice": 88.0,
                "Education, Communication & Collaboration": 85.5,
                "Medication Management": 84.2,
                "Prevention, Safety & Quality": 86.4,
                "Professionalism": 94.5,
                "Readiness": 84.5
            },
            "14": {
                "Assessment & Care": 66.2,
                "Clinical Practice": 82.0,
                "Education, Communication & Collaboration": 82.5,
                "Medication Management": 81.7,
                "Prevention, Safety & Quality": 82.5,
                "Professionalism": 85.0,
                "Readiness": 97.5
            },
            "15": {
                "Assessment & Care": 100.0,
                "Clinical Practice": 100.0,
                "Education, Communication & Collaboration": 100.0,
                "Medication Management": 100.0,
                "Prevention, Safety & Quality": 100.0,
                "Professionalism": 100.0,
                "Readiness": 100.0
            }
        }
    }

    const data2023 = {
        "categories": [
            "Clinical Practice",
            "Medication Management",
            "Assessment & Care",
            "Prevention, Safety & Quality",
            "Education, Communication & Collaboration",
            "Professionalism"
        ],
        "rfp_outcomes": {
            "completed_total": 1,
            "completed_without_rfp": 1,
            "completed_with_three_plus_rfp": 0,
            "avg_week_to_first_rfp": null
        },
        "by_week": {
            "10": {
                "Assessment & Care": 75.0,
                "Clinical Practice": 76.0,
                "Education, Communication & Collaboration": 60.0,
                "Medication Management": 80.0,
                "Prevention, Safety & Quality": 70.0,
                "Professionalism": 80.0,
                "Readiness": 60.0
            }
        }
    }


    let performanceData = {};
    if (filters.fiscal_year === 2027) {
        performanceData = data2027;
    } else if (filters.fiscal_year === 2026) {
        performanceData = data2026;
    } else if (filters.fiscal_year === 2025) {
        performanceData = data2025;
    } else if (filters.fiscal_year === 2024) {
        performanceData = data2024;
    } else if (filters.fiscal_year === 2023) {
        performanceData = data2023;
    }

    // const {
    //     data: planData,
    //     isLoading: planLoading,
    //     error: planError,
    // } = useMetricsQuery("plan-progress", filters, {ratings: {}})

    const planLoading = false
    const planError = null
    const planData = {"ratings":{"Ahead":5,"Behind":5,"On-Schedule":37}}


    const isLoading = performanceLoading || planLoading
    const error = performanceError || planError

    if (error) return <div className="alert alert-danger">Unable to load performance.</div>

    const {categories, rfp_outcomes: rfp, by_week: byWeek} = performanceData
    const fyDisplay = fyLabel(filters.fiscal_year)
    const sortedWeeks = Object.entries(byWeek || {})
        .map(([week, scores]) => ({
            week: Number(week),
            scores,
        }))
        .sort((a, b) => a.week - b.week)

    return (
        <>
            <h2 className="fw-bold mb-4">{fyDisplay} Ready for Practice Outcomes</h2>
            <p className="text-gray-700 fs-6 mb-4">{rfp.completed_total} orientations completed in this fiscal year.</p>
            <div className="d-flex flex-column flex-lg-row gap-8">
                <MetricCard
                    title="Completed Orientation without Scoring RFP"
                    subtitle={fyDisplay}
                    value={rfp.completed_without_rfp}
                    isLoading={isLoading}
                />
                <MetricCard
                    title="Completed Orientation with 3+ RFP Scores"
                    subtitle={fyDisplay}
                    value={rfp.completed_with_three_plus_rfp}
                    isLoading={isLoading}
                />
                <MetricCard
                    title="Average Week Orientees Acheive RFP"
                    subtitle={fyDisplay}
                    value={rfp.avg_week_to_first_rfp?.toFixed(0) ?? "—"}
                    isLoading={isLoading}
                />
            </div>

            <h2 className="fw-bold mb-2 mt-5">Orientation Progress Against Plan</h2>
            <p className="text-gray-700 fs-6 mb-4">
                Latest report for each active orientee. Current status across all fiscal years.
            </p>
            <div className="d-flex flex-row gap-8 mb-8">
                {SCHEDULE_BANDS.map((band) => (
                    <ScheduleCard
                        key={band.key}
                        header={band.header}
                        text={planData.ratings[band.key] ?? 0}
                        background={band.background}
                        isLoading={isLoading}
                    />
                ))}
            </div>

            <div className="card card-xl-stretch mb-xl-8">
                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold fs-2 text-gray-900">
                            Average RFP Score by Week and Domain
                        </span>
                        <span className="fs-6 fw-semibold text-gray-700">Pooled across orientees</span>
                    </h3>
                </div>
                <div className="card-body pt-5">
                    {!isLoading && sortedWeeks.length === 0 ? (
                        <div className="text-muted text-center py-10">No reports match the current filters.</div>
                    ) : (
                        <DomainScoreTable categories={categories} sortedWeeks={sortedWeeks} isLoading={isLoading} />
                    )}
                </div>
            </div>
        </>
    )
}

export default MetricsPerformance
